var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{staticClass:"item-element-renew-btn",attrs:{"type":"text"},on:{"click":_vm.toRenew}},[_vm._v(" "+_vm._s(_vm.$t("vdcontainer.renewal"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }